import {
    MaxCountOfSurgeriesPerSurgeryTypeGroup,
    MaxCountRuleCreate,
    MaxDurationOfSurgeriesPerSurgeryTypeGroup,
    MaxDurationRuleCreate,
} from '~/clients/derived-api-types'
import { isNullish } from '~/utils/guards'

export type RuleDefinitionId = 'max_count_of_surgeries_per_patient_group' | 'max_duration_of_surgeries_per_patient_group'

const ruleDefinition: Record<RuleDefinitionId, string> = {
    max_count_of_surgeries_per_patient_group: 'Antall operasjoner',
    max_duration_of_surgeries_per_patient_group: 'Tilgjengelig tid',
}

export const ruleDefinitionOptions = Object.entries(ruleDefinition).map(([value, label]) => ({
    label,
    value,
}))

export function isRuleDefinitionId(ruleId: string | undefined | null): ruleId is RuleDefinitionId {
    if (isNullish(ruleId)) {
        return false
    }

    return Object.keys(ruleDefinition).includes(ruleId)
}

type RuleInstanceCreateParameters = MaxCountOfSurgeriesPerSurgeryTypeGroup | MaxDurationOfSurgeriesPerSurgeryTypeGroup

export type RuleInstanceParameters = RuleInstanceCreateParameters | undefined | null

export type RuleInstanceCreate = MaxCountRuleCreate | MaxDurationRuleCreate | undefined | null

export function isMaxDuration(parameters: RuleInstanceParameters | undefined): parameters is MaxDurationOfSurgeriesPerSurgeryTypeGroup {
    return !Array.isArray(parameters?.constraints)
}

export function createRuleInstance(localRuleId: RuleDefinitionId, ruleParameters: RuleInstanceCreateParameters): RuleInstanceCreate | null {
    if (localRuleId === 'max_count_of_surgeries_per_patient_group') {
        return {
            name: '',
            rule_definition_id: localRuleId,
            parameters: ruleParameters,
        } as MaxCountRuleCreate
    }

    // Suppressing for readability
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (localRuleId === 'max_duration_of_surgeries_per_patient_group') {
        return {
            name: '',
            rule_definition_id: localRuleId,
            parameters: ruleParameters,
        } as MaxDurationRuleCreate
    }

    return null
}
